import React from 'react';
import * as ReactDOM from 'react-dom';

import { bindActionCreators }  from 'redux';
import { connect }  from 'react-redux';
import Translator from 'bazinga-translator';

import Dragula from 'react-dragula';

import ShowAllDrafts from '../components/ShowAllDrafts.jsx';
import DraftContainer from './DraftContainer.jsx';
import Popup from './PopupContainer.jsx';
import CreateNew from './create_new.jsx';
import Loader from '../components/Loader.jsx';

import * as PopupActions from '../actions/popup_actions';
import * as SettingsActions from '../actions/settings_actions';
import * as DraftActions from '../actions/drafts_actions';

class DraftsList extends React.Component {
    constructor() {
        super();
        this.state = {
            draggingIndex: null
        }
    }

    componentDidMount() {
        this.props.draftActions.initCategories();
    }

    renderPopup() {
        const { activePopup } = this.props.popup;
        if (activePopup) {
            return (
            <Popup />
            )
        }
    }

    updateState(obj) {
        this.setState(obj);
    }

    onDragEnd() {

        this.setState({
            draggingIndex: 0
        });

    }

    dragulaDecorator = (componentBackingInstance) => {
        if (componentBackingInstance) {
            let options = {  };
            Dragula([componentBackingInstance], options).on('dragend',::this.onDragEnd);
        }
    };

    render() {
        const { drafts } = this.props;

        return (
        <div className="box-drafts__wrapper" ref={this.dragulaDecorator}>
            <ShowAllDrafts title={Translator.trans('drafts.see_all_header', [], 'app')}
                           desc={Translator.trans('drafts.see_all_desc', [], 'app')}
                           settings={this.props.settings}/>
            {drafts.sort((a,b) => {
                return a.position - b.position;
            }).map((draft)=> {
                return (
                <DraftContainer key={draft.id} draft={draft} position={draft.position} />
                )
            })}
            {this.renderPopup()}
            <CreateNew translations={this.props.translations}/>
            <div className="box-drafts -blank"></div>
        </div>
        )
    }

}

function mapStateToProps(state) {
    return {
        drafts: state.drafts,
        popup: state.popup,
        translations: state.translations,
        settings: state.settings,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        popupActions: bindActionCreators(PopupActions, dispatch),
        draftActions: bindActionCreators(DraftActions, dispatch),
        settingsActions: bindActionCreators(SettingsActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DraftsList);


// WEBPACK FOOTER //
// ./src/_app/drafts/containers/DraftsList.jsx